export default function (props: any) {
    return (
        <svg width="76" height="76" viewBox="0 0 76 76" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g fill="none" fillRule="evenodd">
                <path d="M0 0h76v76H0z" />
                <g stroke="#979797" strokeLinecap="round" strokeWidth="2">
                    <path d="M31 58.5h15M31 64.5h15M35 69.456h8M30.941 53.324V48.79c.036-7.43-3.958-9.399-6.748-12.542A17.71 17.71 0 0 1 20 24.78C20 14.96 27.96 7 37.78 7c9.819 0 17.779 7.96 17.779 17.78 0 2.308-.44 4.514-1.241 6.538a17.75 17.75 0 0 1-2.33 4.151c-2.126 2.83-6.94 5.765-6.458 13.445v4.41" />
                </g>
            </g>
        </svg>
    );
}
